var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 82,
    viewBox: "0 0 102 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56929_98617)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 100,
    height: 80,
    rx: 8,
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8008 27C85.3472 27 86.6008 28.2536 86.6008 29.8C86.6008 31.3464 85.3472 32.6 83.8008 32.6H67.8008C69.3472 32.6 70.6008 33.8536 70.6008 35.4C70.6008 36.9464 69.3472 38.2 67.8008 38.2H76.6008C78.1472 38.2 79.4008 39.4536 79.4008 41C79.4008 42.5464 78.1472 43.8 76.6008 43.8H72.5312C70.5814 43.8 69.0008 45.0536 69.0008 46.6C69.0008 47.6309 69.8008 48.5643 71.4008 49.4C72.9472 49.4 74.2008 50.6536 74.2008 52.2C74.2008 53.7464 72.9472 55 71.4008 55H38.2008C36.6544 55 35.4008 53.7464 35.4008 52.2C35.4008 50.6536 36.6544 49.4 38.2008 49.4H22.6008C21.0544 49.4 19.8008 48.1464 19.8008 46.6C19.8008 45.0536 21.0544 43.8 22.6008 43.8H38.6008C40.1472 43.8 41.4008 42.5464 41.4008 41C41.4008 39.4536 40.1472 38.2 38.6008 38.2H28.6008C27.0544 38.2 25.8008 36.9464 25.8008 35.4C25.8008 33.8536 27.0544 32.6 28.6008 32.6H44.6008C43.0544 32.6 41.8008 31.3464 41.8008 29.8C41.8008 28.2536 43.0544 27 44.6008 27H83.8008ZM83.8008 38.2C85.3472 38.2 86.6008 39.4536 86.6008 41C86.6008 42.5464 85.3472 43.8 83.8008 43.8C82.2544 43.8 81.0008 42.5464 81.0008 41C81.0008 39.4536 82.2544 38.2 83.8008 38.2Z",
    fill: "#BBDDFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4717 26.5999L66.1924 53.737L66.5267 56.4595C66.6344 57.3366 66.0107 58.1349 65.1336 58.2426L41.7095 61.1187C40.8325 61.2264 40.0341 60.6027 39.9265 59.7256L36.3202 30.3546C36.2663 29.916 36.5782 29.5169 37.0167 29.4631C37.0195 29.4627 37.0222 29.4624 37.025 29.4621L38.9684 29.2441M40.5396 29.0674L42.3744 28.8616L40.5396 29.0674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.967 26.532C62.9295 26.2584 62.6773 26.067 62.4037 26.1045C62.1302 26.142 61.9388 26.3942 61.9763 26.6678L62.967 26.532ZM66.1924 53.737L66.6887 53.676L66.6878 53.6691L66.1924 53.737ZM66.5267 56.4595L67.023 56.3986L66.5267 56.4595ZM65.1336 58.2426L65.1945 58.7388L65.1336 58.2426ZM41.7095 61.1187L41.7705 61.615L41.7095 61.1187ZM39.9265 59.7256L40.4227 59.6647L39.9265 59.7256ZM37.025 29.4621L37.0807 29.959L37.025 29.4621ZM39.0241 29.741C39.2985 29.7102 39.496 29.4628 39.4652 29.1883C39.4345 28.9139 39.187 28.7164 38.9126 28.7472L39.0241 29.741ZM40.4839 28.5706C40.2094 28.6013 40.0119 28.8488 40.0427 29.1232C40.0735 29.3976 40.3209 29.5951 40.5953 29.5643L40.4839 28.5706ZM42.4302 29.3585C42.7046 29.3277 42.9021 29.0803 42.8713 28.8059C42.8405 28.5315 42.5931 28.3339 42.3187 28.3647L42.4302 29.3585ZM61.9763 26.6678L65.697 53.8049L66.6878 53.6691L62.967 26.532L61.9763 26.6678ZM65.6961 53.7979L66.0304 56.5204L67.023 56.3986L66.6887 53.676L65.6961 53.7979ZM66.0304 56.5204C66.1045 57.1234 65.6757 57.6723 65.0727 57.7463L65.1945 58.7388C66.3457 58.5975 67.1643 57.5497 67.023 56.3986L66.0304 56.5204ZM65.0727 57.7463L41.6486 60.6224L41.7705 61.615L65.1945 58.7388L65.0727 57.7463ZM41.6486 60.6224C41.0456 60.6964 40.4968 60.2676 40.4227 59.6647L39.4302 59.7865C39.5715 60.9377 40.6193 61.7563 41.7705 61.615L41.6486 60.6224ZM40.4227 59.6647L36.8164 30.2936L35.8239 30.4155L39.4302 59.7865L40.4227 59.6647ZM36.8164 30.2936C36.7962 30.1292 36.9132 29.9795 37.0776 29.9593L36.9558 28.9668C36.2431 29.0543 35.7364 29.7029 35.8239 30.4155L36.8164 30.2936ZM37.0776 29.9593C37.0787 29.9592 37.0797 29.9591 37.0807 29.959L36.9693 28.9652C36.9648 28.9657 36.9603 28.9662 36.9558 28.9668L37.0776 29.9593ZM37.0807 29.959L39.0241 29.741L38.9126 28.7472L36.9693 28.9652L37.0807 29.959ZM40.5953 29.5643L42.4302 29.3585L42.3187 28.3647L40.4839 28.5706L40.5953 29.5643Z",
    fill: "#0469C5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4571 28.3082L64.8249 52.9017L65.1278 55.369C65.2254 56.1638 64.6678 56.8864 63.8824 56.9828L42.9056 59.5584C42.1202 59.6549 41.4043 59.0887 41.3067 58.2939L38.0467 31.7433C37.9929 31.3047 38.3047 30.9056 38.7433 30.8517L41.3383 30.5331",
    fill: "#E0EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.168 22.6C44.168 21.9925 44.6605 21.5 45.268 21.5H63.4907C63.7823 21.5 64.062 21.6158 64.2683 21.8219L69.6455 27.1959C69.852 27.4022 69.968 27.6821 69.968 27.974V53C69.968 53.6075 69.4755 54.1 68.868 54.1H45.268C44.6605 54.1 44.168 53.6075 44.168 53V22.6Z",
    fill: "white",
    stroke: "#0469C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.668 21.9609V26.5998C63.668 27.2625 64.2052 27.7998 64.868 27.7998H68.0414",
    stroke: "#0469C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1992 48.2008H58.5992M48.1992 27.8008H58.5992H48.1992ZM48.1992 32.6008H65.3992H48.1992ZM48.1992 37.8008H65.3992H48.1992ZM48.1992 43.0008H65.3992H48.1992Z",
    stroke: "#0469C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 100,
    height: 80,
    rx: 8,
    stroke: "#E0EEFE",
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56929_98617"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 100,
    height: 80,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocuments);
export default __webpack_public_path__ + "static/media/NoDocuments.c46e1e1a96760c5a2d357b72d28f028d.svg";
export { ForwardRef as ReactComponent };